export default {
      id: "google-maps-usage",
      viewBox: "0 0 36 36",
      url: __webpack_public_path__ + "app/svg/sprite.svg#google-maps",
      toString: function () {
        return this.url;
      }
    }